import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { selectCompanyInfoData } from './store/slice'

const Footer = () => {
  const company = useSelector(selectCompanyInfoData)
  return (
    <span className="fstItalic">
      <Translate value={'internationalPreview.COMPANY_DETAIL_FOR'} />
      &nbsp;{company.companyName || ''} &nbsp;
      <Translate value={'internationalPreview.COMPANY_SOURCE'} />
    </span>
  )
}

export default Footer
